import $, { each } from "jquery";
//モーダルを表示
export function modal() {
  $("#js-modal").addClass("is-active");
  const num_scroll = $(window).scrollTop();
  $("body").addClass("is-modal-fixed").css({ top: -num_scroll });
  $("#js-btn__closeModal").click(() => {
    $("#js-modal").removeClass("is-active");
    $("body").removeClass("is-modal-fixed").css({ top: "auto" });
    $(window).scrollTop(num_scroll);
  });
}
